module.exports = __webpack_public_path__ + "img/7.8f93b2b2.webp";